<template>
        <form class="search-form inline" v-on:submit.prevent="">
          <div class="search-form-field ext-input">
            <select v-model="componentField">
              <option :value="null">All</option>
              <option v-for="listField in fields" :value="listField.name">{{ listField.title }}</option>
            </select>
          </div>
          <div class="search-form-field ext-input">
            <div class="autocomplete">
              <input placeholder="Search..." v-model="componentValue" />
            </div>
          </div>
          <div class="search-form-field ext-input">
            <button class="search">Search</button>
          </div>
        </form>
</template>

<script>
export default {
  props: ["modelValue", "field", "fields"],
  computed: {
    componentField: {
      get() {
        return this.field;
      },
      set(value) {
        this.$emit("update:field", value);
      },
    },
    componentValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
}
</script>
